export const testProps = (reference: string): Object => ({
  testID: reference,
  accessibilityLabel: reference,
});
